import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';
import {
  MatTableDataSource,
  MatPaginator,
  MatSort,
  PageEvent
} from '@angular/material';
import { MatDialog } from '@angular/material';
import { ProductService } from '../_service/product.service';
import { AlertifyService } from '../_service/alertify.service';
import { ProductPageComponent } from './product-page/product-page.component';
import { AuthService } from '../_service/auth.service';
import { Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import {
  FormControl,
  Validators,
  FormBuilder,
  FormGroup
} from '@angular/forms';
import { TreeComponent } from '../tree/tree.component';
import { SelectionModel } from '@angular/cdk/collections';
import { HeaderComponent } from '../navigation/header/header.component';
import { ActivatedRoute } from '@angular/router';
import { ProductLabelComponent } from '../product-label/product-label.component';
import { FileuploadService } from '../_service/fileupload.service';
import { MessageHandlerService } from '../_service/message-handler.service';

export class TodoItemNode {
  authorityUnitId: number;
  parentAuthorityUnitId: number;
  rootAuthorityUnitId: number;
  name: string;
  children?: TodoItemNode[];
  hasChild: boolean;
  exists: boolean;
}

/** Flat to-do item node with expandable and level information */
export class TodoItemFlatNode {
  authorityUnitId: number;
  parentAuthorityUnitId: number;
  rootAuthorityUnitId: number;
  item: string;
  level: number;
  expandable: boolean;
  checked: boolean;
}

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, AfterViewInit {
  locations = [];
  searchString: any;
  searchResultIsEmpty = true;
  searchForm: FormGroup;
  unsubscribe = new Subject<void>();

  MyDataSource: any;
  MyDataSource1: any;

  @ViewChild(HeaderComponent, { static: true }) header: HeaderComponent;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(TreeComponent, { static: false }) locationTree: TreeComponent;

  isLoading = false;
  hideButton = false;
  selectedSearchDropDown: any;

  emptySearchResponse: any = {};

  value = '';
  productNameFilterValue = '';
  mfgFilterValue = '';
  productCodeFilterValue = '';
  casNoFilterValue = '';

  message: any;
  errorMessage = false;

  productNameFilterIsClear: boolean;
  productCodeFilterIsClear: boolean;
  mfgNameFilterIsClear: boolean;
  casNoFilterIsClear: boolean;

  selectedParam: any;

  // search parameters
  model: any = {};
  searchParms: any = [];
  products: any = [];
  vendorProducts: any = [];
  allProducts: any = [];
  selectedProduct;
  searchBarForm: FormGroup;
  disablePaging: boolean;
  sortDirection: any;
  displayedColumns: string[] = [
    'product_name',
    'mfg_detail',
    'product_code',
    'revisionDate',
    'lastVerified',
    'viewSDS',
    'printLabel'
  ];

  filterValues = {
    product_name: '',
    mfg_detail: '',
    Revised: '',
    product_code: '',
    cas_no: '',
    LastVerified: ''
  };

  manufacturerFilter = new FormControl('');
  productCodeFilter = new FormControl('');
  casNumberFilter = new FormControl('');
  productNameFilter = new FormControl('');

  selectedSearchParameter;
  selectFormControl = new FormControl(
    { value: '', disabled: true },
    Validators.required
  );
  selectedParameter = 'searchString';
  disableSearchInput = false;
  fileInfo: any = null;
  sdsexists: any;
  loading = false;

  loginNotice = 'Please login to view the Safety Data Sheets.';
  selection = new SelectionModel<SearchSDSModel>(true, []);

  @Input() totalCount: number;
  @Input() currentPage: number;
  @Input() itemsPerPage: number;
  @Input() totalItems: number;
  @Input() totalPages: number[];
  @Input() pageIndex: number;
  @Input() pageSizeOptions: number[] = [5, 10, 20];
  @Input() pageSize: number;
  @Input() nextPage: number;
  @Input() previousPage: number;

  constructor(
    private productService: ProductService,
    private alertify: AlertifyService,
    private dialog: MatDialog,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    public fb: FormBuilder,
    private route: ActivatedRoute,
    private fileService: FileuploadService,
    private messageHandler: MessageHandlerService
  ) {
    if (this.products.body) {
      this.MyDataSource.data = this.products.body;
      this.MyDataSource.filterPredicate = this.tableFilter();
    }

    this.searchBarForm = fb.group({
      searchStringControl: new FormControl({ value: '', disabled: this.selectedParameter === 'searchString' })
    });

    // clear row id for highlighting table row
    this.dialog.afterAllClosed.subscribe(result => {
      this.selectedRowIndex = 0;
    });
  }

  setLoadingState = (isLoading) => {};

  tableFilter(): (data: any, filter: string) => boolean {
    const filterFunction = function(data, filter): boolean {
      const searchTerms = JSON.parse(filter);

      if (searchTerms.mfg_detail !== '' && data.mfg_detail !== null) {
        return (
          data.mfg_detail.toString().indexOf(searchTerms.mfg_detail) !== -1
        );
      } else if (
        searchTerms.product_code !== '' &&
        data.product_code !== null
      ) {
        return (
          data.product_code.toLowerCase().indexOf(searchTerms.product_code) !==
          -1
        );
      } else if (searchTerms.product_name !== '') {
        return (
          data.product_name.toLowerCase().indexOf(searchTerms.product_name) !==
          -1
        );
      } else {
        return true;
      }
    };
    return filterFunction;
  }

  limitProductCodeChar(productCode) {
    // console.log(productCode);
    if (productCode.length > 30) {
      return productCode.substring(0, 27) + '...';
    } else {
      return productCode;
    }
  }

  sortData(event) {
    this.sortDirection = event.direction;
    this.searchProducts();
  }

  ngOnInit() {
    // Handle all messages (auth redirects and password reset links)
    this.messageHandler.handleAllMessages(this.route);

    this.selectedParameter = 'productName';
    this.selectedSearchParameter = 'productName';
    
    this.setControlState();
    
    this.productNameFilterFunction();
    this.productCodeFilterFunction();
    this.manufacturerFilterFunction();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setControlState();
      this.cdr.detectChanges();
    });
  }

  setControlState() {
    if (this.selectedParameter === 'searchString') {
      this.searchBarForm.controls['searchStringControl'].disable();
    } else {
      this.searchBarForm.controls['searchStringControl'].enable();
    }
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  productNameFilterFunction() {
    this.productNameFilter.valueChanges
      .pipe(debounceTime(800))
      .subscribe(product_name => {
        this.filterValues.product_name = product_name.trim();
        this.filterValues.product_name = product_name.toLowerCase();
        if (this.products.body && this.filterValues.product_name.length !== 0) {
          this.MyDataSource.filter = JSON.stringify(this.filterValues);
          this.MyDataSource.data = [];
          this.paginator.firstPage();
          this.searchProducts();
        }
        if (this.products.body && this.productNameFilterIsClear) {
          this.MyDataSource.data = [];
          this.paginator.firstPage();
          this.searchProducts();
        }
      });
  }

  productCodeFilterFunction() {
    this.productCodeFilter.valueChanges
      .pipe(debounceTime(800))
      .subscribe(product_code => {
        this.filterValues.product_code = product_code.trim();
        this.filterValues.product_code = product_code.toLowerCase();
        if (this.products.body && this.filterValues.product_code.length !== 0) {
          this.MyDataSource.filter = JSON.stringify(this.filterValues);
          this.MyDataSource.data = [];
          this.paginator.firstPage();
          this.searchProducts();
        }
        if (this.products.body && this.productCodeFilterIsClear) {
          this.MyDataSource.data = [];
          this.paginator.firstPage();
          this.searchProducts();
        }
      });
  }

  manufacturerFilterFunction() {
    this.manufacturerFilter.valueChanges
      .pipe(debounceTime(800))
      .subscribe(mfg_detail => {
        this.filterValues.mfg_detail = mfg_detail.trim();
        this.filterValues.mfg_detail = mfg_detail.toLowerCase();
        if (this.products.body && this.filterValues.mfg_detail.length !== 0) {
          this.MyDataSource.filter = JSON.stringify(this.filterValues);
          this.MyDataSource.data = [];
          this.paginator.firstPage();
          this.searchProducts();
        }
        if (this.products.body && this.mfgNameFilterIsClear) {
          this.MyDataSource.data = [];
          this.paginator.firstPage();
          this.searchProducts();
        }
      });
  }

  loggedIn() {
    return this.authService.loggedIn();
  }

  testchecked = false;
  selectedRow = false;

  getTest(row) {
    console.log(row);
  }

  openDiaglogProductPage(row) {
    this.testchecked = false;
    const dialogRef = this.dialog.open(ProductPageComponent, {
      width: '1000px',
      data: {
        productId: row['productId'],
        product_name: row['product_name'],
        mfg_detail: row['mfg_detail'],
        product_code: row['product_code'],
        product_code_array: row['product_code_array'],
        synonyms: row['synonyms'],
        cas_no: row['cas_no'],
        productAlias: row['productAlias'],
        productNotes: row['productNote'],
        additionalSuppliers: row['additionalSuppliers'],
        exempt: row['exempt'],
        ref_id: row['ref_id'],
        msdsId: row['msds_id'],
        internal: row['internal'],
        selectedRow: row.selectedRow
      }
    });

    this.checkSelectedRow(dialogRef.componentInstance.productSelectedRow);
    dialogRef.afterClosed().subscribe(result => {
      this.testchecked = false;
    })
  }

  checkSelectedRow(selectedRow) {
    if (selectedRow) {
      this.testchecked = true;
      return true;
    } else {
      this.testchecked = false;
      return false;
    }
  }

  hideButtons() {
    return this.loggedIn();
  }

  openProductLabelGeneration(product) {
    const dialogRef = this.dialog.open(ProductLabelComponent, {
      width: '1000px',
      height: '600px',
      data: {
        productId: product.productId,
        productName: product.product_name,
        productCode: product.product_code,
        mfg_detail: product.mfg_detail
      }
    });
  }

  sdsID: any;

  getSDSPDF(product) {
    if (!product.externalProductId) { return; }
    const sdsUrl = `${window.location.origin}/view/${product.externalProductId}`;
    window.open(sdsUrl, '_blank');
  }

  isInActive() {
    if (this.authService.decodedToken.role === 'InActive') {
      return true;
    } else {
      return false;
    }
  }

  invalidSearchResultMessage(message) {
    if (message) {
      this.message = message;
      this.isLoading = false;
      this.setLoadingState(false);
    } else {
      this.message = '';
    }
  }

  onSelectParameter(event) {
    this.selectedSearchParameter = event.value;
    this.setControlState();
  }

  // disable filter input boxes if search result is invalid
  disableFilterInput() {
    if (this.emptySearchResponse) {
      return false;
    } else {
      return true;
    }
  }

  clearInputBox() {
    this.value = '';
    this.searchString = '';

    // clear filter input boxes
    this.clearProductNameInputBox();
    this.clearMFGNameInputBox();
    this.clearProductCodeInputBox();
  }

  clearProductNameInputBox() {
    this.productNameFilterIsClear = true;
    this.productNameFilterValue = '';
    this.filterValues.product_name = '';
  }

  clearMFGNameInputBox() {
    this.mfgNameFilterIsClear = true;
    this.mfgFilterValue = '';
    this.filterValues.mfg_detail = '';
  }

  clearProductCodeInputBox() {
    this.productCodeFilterIsClear = true;
    this.productCodeFilterValue = '';
    this.filterValues.product_code = '';
  }

  searchForProducts(selectedValue: string) {
    this.allProducts = [];
    this.sortDirection = null;
      this.searchString = selectedValue;
      const searchObj: searchObject = {
        searchProductName: '',
        searchProductCode: '',
        searchMfgName: ''
      };
      if (this.selectedSearchParameter === 'productName') {
        searchObj.searchProductName = selectedValue;
      }
      if (this.selectedSearchParameter === 'productCode') {
        searchObj.searchProductCode = selectedValue;
      }
      if (this.selectedSearchParameter === 'manufacturer') {
        searchObj.searchMfgName = selectedValue;
      }
      // return to first page when submit button or enter is clicked.
      this.paginator.firstPage();
      this.searchProducts();
    }

  searchProductName(searchBoxProductName: string) {
    this.allProducts = [];
    this.searchString = searchBoxProductName;
    const searchObj: searchObject = {
      searchProductName: '',
      searchProductCode: '',
      searchMfgName: ''
    };

    searchObj.searchProductName = searchBoxProductName;
    searchObj.searchProductCode = '';
    searchObj.searchMfgName = '';
    this.searchProducts();
  }

  searchProductCode(searchBoxProductCode: string) {
    this.allProducts = [];
    this.searchString = searchBoxProductCode;
    const searchObj: searchObject = {
      searchProductName: '',
      searchProductCode: '',
      searchMfgName: ''
    };

    searchObj.searchProductName = '';
    searchObj.searchProductCode = searchBoxProductCode;
    searchObj.searchMfgName = '';

    this.searchProducts();
  }

  searchManufacturer(searchBoxManufacturer: string) {
    this.allProducts = [];
    this.searchString = searchBoxManufacturer;
    const searchObj: searchObject = {
      searchProductName: '',
      searchProductCode: '',
      searchMfgName: ''
    };

    searchObj.searchProductName = '';
    searchObj.searchProductCode = '';
    searchObj.searchMfgName = searchBoxManufacturer;

    this.searchProducts();
  }

  selectedRowIndex = -1;

  selectRow(row) {
    this.testchecked = false;
    this.selectedRowIndex = row.productId;

    this.openDiaglogProductPage(row);
  }

  // disables hazard class filters if drop down box is not on 'All Records'
  disableHazardClassFilters(): boolean {
    if (this.selectedParameter !== 'searchString') {
      return false;
    }
    if (!this.products.body) {
      return false;
    } else {
      return true;
    }
  }

  searchResultIsNull() {
    if (this.products.body.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  pageChanged(event: PageEvent) {
    this.totalItems = event.length;
    this.pageIndex = event.pageIndex;
    this.nextPage = event.pageSize;
    this.searchProducts();
  }

  restrictFilterParams() {
    if (this.selectedParameter === 'searchString') {
      return false;
    }
    if (
      (this.selectedParameter === 'productName' && this.searchString === '') ||
      !this.products.body
    ) {
      return false;
    }
    if (
      (this.selectedParameter === 'productCode' && this.searchString === '') ||
      !this.products.body
    ) {
      return false;
    }
    if (
      (this.selectedParameter === 'manufacturer' && this.searchString === '') ||
      !this.products.body
    ) {
      return false;
    } else {
      return true;
    }
  }

  restrictHeaderFilterParams() {
    if (this.selectedSearchParameter === 'searchString') {
      return false;
    }
    if (
      (this.selectedSearchParameter === 'productName' && this.searchString === '') ||
      !this.products.body
    ) {
      return false;
    }
    if (
      (this.selectedSearchParameter === 'productCode' && this.searchString === '') ||
      !this.products.body
    ) {
      return false;
    }
    if (
      (this.selectedSearchParameter === 'manufacturer' && this.searchString === '') ||
      !this.products.body
    ) {
      return false;
    } else {
      return true;
    }
  }

  restrictDropDownParams() {
    if (this.selectedSearchParameter === 'productName' && this.searchString === '') {
      this.isLoading = false;
      this.setLoadingState(false);
      this.alertify.message('Please enter a search parameter');
      return false;
    }
    if (this.selectedSearchParameter === 'productCode' && this.searchString === '') {
      this.isLoading = false;
      this.setLoadingState(false);
      this.alertify.message('Please enter a search parameter');
      return false;
    }
    if (this.selectedSearchParameter === 'manufacturer' && this.searchString === '') {
      this.isLoading = false;
      this.setLoadingState(false);
      this.alertify.message('Please enter a search parameter');
      return false;
    } else {
      return true;
    }
  }

  searchProducts() {
    if (this.isLoading === true) { return; }
    this.isLoading = true;
    this.setLoadingState(this.isLoading);

    this.hideButton = true;
    this.pageSize = this.pageSizeOptions[1];

    const findObj: SearchCloudSDSObject = {
      productName: '',
      productCode: '',
      productCodeFilter: '',
      productNameFilter: '',
      mfgName: '',
      mfgNameFilter: '',
      searchString: '',
      pageNumber: null,
      pageSize: null,
      sortDirection: null
    };

    if (this.selectedSearchParameter === 'productName') {
      findObj.productName = this.searchString.trim();
    }
    if (this.filterValues.product_name !== '') {
      findObj.productNameFilter = this.filterValues.product_name.trim();
    }

    if (this.selectedSearchParameter === 'productCode') {
      findObj.productCode = this.searchString.trim();
    }
    if (this.filterValues.product_code !== '') {
      findObj.productCodeFilter = this.filterValues.product_code.trim();
    }
    if (this.selectedSearchParameter === 'manufacturer') {
      findObj.mfgName = this.searchString.trim();
    }
    if (this.filterValues.mfg_detail !== '') {
      findObj.mfgNameFilter = this.filterValues.mfg_detail.trim();
    }
    if (this.selectedSearchParameter === 'searchString') {
      findObj.searchString = this.searchString;
    }

    findObj.pageNumber = this.pageIndex;
    findObj.pageSize = this.nextPage;
    findObj.sortDirection = this.sortDirection;

    if (this.restrictDropDownParams()) {
      // findProducts combined result from local database
      this.errorMessage = false;
      return this.productService
        .findProducts(findObj)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res: any) => {
            this.emptySearchResponse = res.headers.get('nosearchresult');

            if (res.body) {
              this.products = res;
              for (const response of this.products.body) {
                this.allProducts.push(response);
              }

              this.currentPage = JSON.parse(
                res.headers.get('pagination')
              ).currentPage;
              this.itemsPerPage = JSON.parse(
                res.headers.get('pagination')
              ).itemsPerPage;
              this.totalItems = JSON.parse(
                res.headers.get('pagination')
              ).totalItems;
              this.totalPages = JSON.parse(
                res.headers.get('pagination')
              ).totalPages;

              this.isLoading = false;
              this.setLoadingState(false);
              this.testchecked = false;

              this.MyDataSource = new MatTableDataSource<Element>(res);
              this.MyDataSource.data = res.body;
              this.MyDataSource.sort = this.sort;
              this.MyDataSource.filterPredicate = this.tableFilter();
              this.disablePaging = false;
              this.searchResultIsEmpty = false;

            } else if (this.emptySearchResponse) {
              this.invalidSearchResultMessage(this.emptySearchResponse);
              this.errorMessage = true;
              this.isLoading = false;
              this.setLoadingState(false);
              this.MyDataSource !== undefined ? this.MyDataSource.data = [] : this.MyDataSource = null;
              this.searchResultIsEmpty = false;
              this.disablePaging = true;
            }
          },
          error => {
            this.searchResultIsEmpty = true;
            this.isLoading = false;
            this.setLoadingState(false);
          },
          () => {
            this.isLoading = false;
            this.setLoadingState(false);
          }
        );
    }
  }
}

export interface ProductInterface {
  product_name: string;
  mfg_name: string;
  product_code: string;
  productAlias: string;
  productNodes: string;
  additionalSupplier: string;
  exemptionclassFlag: string;
  internal: string;
}

export interface searchObject {
  searchProductName: string;
  searchProductCode: string;
  searchMfgName: string;
}

export interface SearchCloudSDSObject {
  productName: string;
  productNameFilter: string;
  productCode: string;
  productCodeFilter: string;
  mfgName: string;
  mfgNameFilter: string;
  searchString: string;
  pageNumber: number;
  pageSize: number;
  sortDirection: string;
}

export interface SearchSDSModel {
  productId: number;
  rootAuthorityUnitId: number;
  product_name: string;
  mfg_name: string;
  product_code: string;
  addedToInventory: boolean;
  revision_date: string;
  last_verified: string;
  discontinued: boolean;
  whmis_exempt: boolean;
  position: number;
}